module.exports = __webpack_public_path__ + "static/media/historier.30bad5df.mp3";